import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BackendUrlConfig, ConfigService } from '@ps-gui/shared-core';

@Injectable({
  providedIn: 'root',
})
export class AuditCopyService {
  private readonly configService = inject(ConfigService<BackendUrlConfig>);
  private readonly http = inject(HttpClient);

  getAuditSourceId(auditId: string): Observable<string> {
    return this.http.get<string>(
      `${this.configService.config.psBackendUrl}/audit/${auditId}/source`,
    );
  }
}
